import React from 'react';
import TabRouting from '../../components/TabRouting';

const selectedMainTabIndex = 1;
const OverrideMainPage = () => {
    return <TabRouting selectedMainTabIndex={selectedMainTabIndex}></TabRouting>;
};

export default OverrideMainPage;
